module.exports = __webpack_public_path__ + "img/flowers.8a3ee42d.jpg";